import React from 'react';
import "./Work.scss";

const Work = ({work}) => {
	return (
		<div className="col col-xs-12 col-md-4 work">
			<a href={work.link_do_imdb} target="_blank" rel="noopener noreferrer" >
				<img
					src={work.poster}
					alt={`Poster: ${work.tytul_filmu}`}
					width={480}
					height={776} />
			</a>
		</div>
	);
};

export default Work;